import type React from 'react';

const StatsIcon: React.FC = () => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <title>Statistics Icon</title>
    <g
      stroke="#747474"
      strokeWidth="1.8"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <path d="M3.563 20.875h16.875M3.563 20.875V4M3.563 20.875l6.75-9M13.688 16.375l-3.375-4.5M13.688 16.375l6.75-7.875" />
    </g>
  </svg>
);

export default StatsIcon;
